import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ParametroService } from 'src/app/services/parametroService';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { AsignarSeccionComponent } from './asignar-seccion/asignar-seccion.component';
import { NewRolComponent } from './new-rol/new-rol.component';

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.css']
})
export class RolComponent implements OnInit {

  displayedColumns: string[] = ['nro', 'nombre', 'asignar', 'opciones'];
  dataSource = new MatTableDataSource();
  nro: number = 0;

  constructor(
      private usuarioService: UsuarioService,
      private dialog: MatDialog,
      private alert: AlertService) { }

  ngOnInit(): void {
    this.listar();
  }

  listar() {
    this.usuarioService.getRoles()
      .subscribe((data:any) => {
        this.dataSource = new MatTableDataSource(data.data.data);
      });
  }

  public doFilter(strBuscar: string) {
    this.dataSource.filter = strBuscar.trim().toLocaleLowerCase();
  }

  agregar() {
    const dialogRef = this.dialog.open(NewRolComponent, {
      disableClose: true
    });
    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.listar();
        }
      });
  }

  editar(id: number) {
    this.usuarioService.getRolById(id)
      .subscribe((data: any) => {
        if (data.status !== 200) {
          this.alert.showInfo('warning');
          return;
        }
        const dialogRef = this.dialog.open(NewRolComponent, {
          disableClose: true,
          data: data.data.data
        });
        dialogRef.afterClosed()
          .subscribe(result => {
            if (result) {
              this.listar();
            }
          });
      },
      (err) => {
        this.alert.showInfo('error');
      });
  }

  eliminar(id: number) {
    let param: {} = this.alert.getParamConfirm();
    Swal.fire(param)
      .then((result) => {
        if (result.isConfirmed) {
          this.usuarioService.deleteRol(id)
            .subscribe((data: any) => {
              if (data.data.status !== 200) {
                this.alert.showWarningCustom(data.data.mensaje);
                return;
              } else {
                this.alert.showDelete('ok');
                this.listar();
              }
            });
        }
      });
  }

  asignarSecciones(id: number) {
    const dialogRef = this.dialog.open(AsignarSeccionComponent, {
      disableClose: true,
      minWidth: "640px",
      maxHeight: "92vh",
      data: {
        id: id
      }
    });
    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.listar();
        }
      });
  }

}
